import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo.png';
import Recharge from '../Recharge/Recharge';
import Portfolio from '../Portfolio/Portfolio';
import VirtualCard from '../VirtualCard/VirtualCard';
import TransactionHistory from '../TransactionHistory/TransactionHistory';

import './Dashboard.css';

const Dashboard = ({ handleLogout, userEmail = "robinhood@gmail.com" }) => {
    const [activeTab, setActiveTab] = useState('portfolio');
    const [showUserMenu, setShowUserMenu] = useState(false);

    const getInitial = (email) => {
        return email ? email.charAt(0).toUpperCase() : 'U';
    };

    return (
        <div className="dashboard-container">
            <header className="dashboard-header">
                <div className="header-left">
                    <img src={logo} alt="Logo" className="dashboard-logo" />
                </div>
                <div className="header-right">
                    <div
                        className="user-profile"
                        onMouseEnter={() => setShowUserMenu(true)}
                        onMouseLeave={() => setShowUserMenu(false)}
                    >
                        <div className="user-avatar">
                            {getInitial(userEmail)}
                        </div>
                        {showUserMenu && (
                            <div className="user-dropdown">
                                <p className="user-email">{userEmail}</p>
                                <button onClick={handleLogout} className="logout-btn">退出登录</button>
                            </div>
                        )}
                    </div>
                </div>
            </header>
            <div className="dashboard-main">
                <aside className="dashboard-sidebar">
                    <nav>
                        <ul>
                            <li
                                className={activeTab === 'portfolio' ? 'active' : ''}
                                onClick={() => setActiveTab('portfolio')}
                            >
                                <svg viewBox="0 0 24 24"><path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" /></svg>
                                Portfolio
                            </li>
                            <li
                                className={activeTab === 'deposit' ? 'active' : ''}
                                onClick={() => setActiveTab('deposit')}
                            >
                                <svg viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" /></svg>
                                Deposit
                            </li>
                            <li
                                className={activeTab === 'virtual-card' ? 'active' : ''}
                                onClick={() => setActiveTab('virtual-card')}
                            >
                                <svg viewBox="0 0 24 24"><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" /></svg>
                                Virtual Card
                            </li>
                            <li
                                className={activeTab === 'transactions' ? 'active' : ''}
                                onClick={() => setActiveTab('transactions')}
                            >
                                <svg viewBox="0 0 24 24"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" /></svg>
                                Transaction History
                            </li>
                        </ul>
                    </nav>
                </aside>
                <main className="dashboard-content">
                    {activeTab === 'portfolio' && (
                        <div className="content-pane portfolio-pane">
                            <Portfolio setActiveTab={setActiveTab} />
                        </div>
                    )}
                    {activeTab === 'deposit' && (
                        <div className="content-pane deposit-pane">
                            <Recharge />
                        </div>
                    )}
                    {activeTab === 'virtual-card' && (
                        <div className="content-pane virtual-card-pane">
                            <VirtualCard />
                        </div>
                    )}
                    {activeTab === 'transactions' && (
                        <div className="content-pane transactions-pane">
                            <TransactionHistory />
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
};

export default Dashboard;